import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { AlignItemsProps, DisplayProps } from 'styled-system';
import { alignItems, display } from 'styled-system';

import { CaptionRegularCR1 } from 'common/components/Typography';
import type { PropsWithRequiredChildren } from 'common/types/React';

const BaseText = styled(CaptionRegularCR1)<DisplayProps & AlignItemsProps>`
  ${display};
  ${alignItems};
`;

const textStyles: ComponentProps<typeof BaseText> = {
  as: 'p',
  display: 'flex',
  alignItems: 'center',
  py: ['sp_4', null, 'sp_6'],
  m: 'sp_0',
  color: 'sys.neutral.text.inverted',
};

type TextProps = ComponentProps<typeof BaseText>;

const Text = ({ children, ...props }: PropsWithRequiredChildren<TextProps>) => (
  <BaseText {...textStyles} {...props}>
    {children}
  </BaseText>
);

export default Text;
